import { FC } from 'react';
import { IPOUtils } from '@hylaa-npm/ipod';

import { PUpload } from '.';
import { BASEURL } from '@/apis';

import avatarIcon from '@/images/staff/avatar.svg';

import { UploadWrap } from './style';

interface IUserAvatarUploadProps {
	avatar?: string;
	changeAvatar: (id: string) => void;
}

const UserAvatarUpload: FC<IUserAvatarUploadProps> = ({ avatar, changeAvatar }) => {
	return (
		<UploadWrap>
			<PUpload
				handleUploadPre={(data) => changeAvatar(data.id)}
				multiple={false}
				accept=".png, .jpg, .jpeg, .webp">
				{avatar ? (
					<img src={IPOUtils.getFileUrl(BASEURL, avatar)} alt="" />
				) : (
					<img src={avatarIcon} alt="" />
				)}
			</PUpload>
		</UploadWrap>
	);
};

export default UserAvatarUpload;
